import React from "react";
import StockMovementFlow from "../components/StockMovementFlow";

export default function Warenausgang() {
  return (
    <StockMovementFlow
      title="Warenausgang"
      color="red"
      endpoint="/goods-issues"
      transfer={false}
      showPrice={false}
      testIdPrefix="wa"
    />
  );
}
